import React from "react";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { ClientInvoiceInfo } from "../../components/client";

export const ClientInvoice = () => {
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title="Client Invoice" />
      </Box>

      <ClientInvoiceInfo />
    </PageLayout>
  );
};
